import { render, staticRenderFns } from "./workorderyear.vue?vue&type=template&id=0fed9e8f&"
import script from "./workorderyear.vue?vue&type=script&lang=js&"
export * from "./workorderyear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports